const hasSlick = () => {
  return !!(window.jQuery && window.jQuery.fn && window.jQuery.fn.slick)
}

const carouselTracks = () => document.querySelectorAll("[data-slick-carousel]")

const slideSelectorFor = (track) => {
  return track.dataset.slickSlideSelector || ".slick-slide"
}

const profileFor = (track) => track.dataset.slickProfile || "default"

const galleryReelProfileFor = (track) => profileFor(track) === "gallery-reel"

const slidesFor = (track) => track.querySelectorAll(slideSelectorFor(track))

const configuredSlidesToShowFor = (track) => {
  const configuredSlidesToShow = Number.parseInt(track.dataset.slickSlidesToShow || "3", 10)

  return Number.isNaN(configuredSlidesToShow) || configuredSlidesToShow < 1 ? 3 : configuredSlidesToShow
}

const minSlidesForCarouselFor = (track) => {
  const configuredMinimum = Number.parseInt(track.dataset.slickMinSlidesForCarousel || "", 10)

  if (!Number.isNaN(configuredMinimum) && configuredMinimum >= 0) {
    return configuredMinimum
  }

  return configuredSlidesToShowFor(track)
}

const carouselEnabledFor = (track) => track.dataset.slickCarousel !== "false"

const slideCountFor = (track) => slidesFor(track).length

const initialSlideFor = (track) => {
  if (!galleryReelProfileFor(track)) return 0

  const slideCount = slideCountFor(track)
  return Math.max(0, Math.floor(slideCount / 2))
}

const shouldUseCarousel = (track) => {
  if (galleryReelProfileFor(track)) {
    return carouselEnabledFor(track) && slideCountFor(track) > 0
  }

  return carouselEnabledFor(track) && slideCountFor(track) > minSlidesForCarouselFor(track)
}

const carouselSignatureFor = (track) => {
  return `${configuredSlidesToShowFor(track)}:${slideCountFor(track)}`
}

const responsiveSlidesToShowFor = (configuredSlidesToShow, maxSlides) => {
  return Math.min(configuredSlidesToShow, maxSlides)
}

const markTrackReady = (track) => {
  const readyClass = track.dataset.slickReadyClass
  if (!readyClass) return

  track.classList.add(readyClass)
}

const refreshCarousel = (track) => {
  if (track.dataset.slickInitialized !== "1" || !hasSlick()) return

  if (galleryReelProfileFor(track)) {
    if (slideCountFor(track) <= 1) {
      markTrackReady(track)
      return
    }

    centerGalleryReelOnSlide(track, initialSlideFor(track))
    return
  }

  window.jQuery(track).slick("setPosition")
}

const bindRefreshOnImageLoad = (track) => {
  if (track.dataset.slickRefreshBound === "1") return

  track.dataset.slickRefreshBound = "1"

  track.querySelectorAll("img").forEach((image) => {
    if (image.complete) return

    const refresh = () => refreshCarousel(track)

    image.addEventListener("load", refresh, { once: true })
    image.addEventListener("error", refresh, { once: true })
  })
}

const destroyCarousel = (track) => {
  if (track.dataset.slickInitialized !== "1" || !hasSlick()) return

  window.jQuery(track).slick("unslick")
  delete track.dataset.slickInitialized
  delete track.dataset.slickSignature
}

const centerGalleryReelOnSlide = (track, slideIndex) => {
  requestAnimationFrame(() => {
    window.jQuery(track).slick("setPosition")
    requestAnimationFrame(() => {
      window.jQuery(track).slick("slickGoTo", slideIndex, true)
      requestAnimationFrame(() => {
        window.jQuery(track).slick("setPosition")
        markTrackReady(track)
      })
    })
  })
}

const galleryReelOptionsFor = (track, slideCount) => {
  return {
    arrows: true,
    dots: false,
    infinite: slideCount > 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    draggable: true,
    variableWidth: true,
    centerMode: true,
    centerPadding: "0px",
    initialSlide: initialSlideFor(track),
    adaptiveHeight: false
  }
}

const slickOptionsFor = (track) => {
  const slideCount = slideCountFor(track)
  const configuredSlidesToShow = configuredSlidesToShowFor(track)

  if (galleryReelProfileFor(track)) {
    return galleryReelOptionsFor(track, slideCount)
  }

  return {
    arrows: true,
    dots: true,
    infinite: slideCount > configuredSlidesToShow,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    variableWidth: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: responsiveSlidesToShowFor(configuredSlidesToShow, 2),
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: responsiveSlidesToShowFor(configuredSlidesToShow, 3),
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: configuredSlidesToShow,
          slidesToScroll: 1
        }
      }
    ]
  }
}

const initCarousel = (track) => {
  if (!hasSlick()) return

  const carouselSignature = carouselSignatureFor(track)

  if (!shouldUseCarousel(track)) {
    destroyCarousel(track)
    markTrackReady(track)
    return
  }

  if (track.dataset.slickInitialized === "1") {
    if (track.dataset.slickSignature === carouselSignature) {
      refreshCarousel(track)
      markTrackReady(track)
      return
    }

    destroyCarousel(track)
  }

  window.jQuery(track).slick(slickOptionsFor(track))

  track.dataset.slickInitialized = "1"
  track.dataset.slickSignature = carouselSignature
  bindRefreshOnImageLoad(track)

  if (galleryReelProfileFor(track)) {
    if (slideCountFor(track) > 1) {
      centerGalleryReelOnSlide(track, initialSlideFor(track))
      return
    }

    markTrackReady(track)
    return
  }

  refreshCarousel(track)
  markTrackReady(track)
}

const initCarousels = () => {
  carouselTracks().forEach((track) => {
    initCarousel(track)
  })
}

const scheduleCarousels = (attempts = 0) => {
  if (!hasSlick()) {
    if (attempts >= 20) {
      carouselTracks().forEach((track) => markTrackReady(track))
      return
    }

    requestAnimationFrame(() => scheduleCarousels(attempts + 1))
    return
  }

  initCarousels()
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => scheduleCarousels())
} else {
  scheduleCarousels()
}

document.addEventListener("turbo:load", () => scheduleCarousels())
document.addEventListener("turbo:render", () => scheduleCarousels())
window.addEventListener("load", () => scheduleCarousels())
window.addEventListener("pageshow", () => scheduleCarousels())
